class WebChat extends Widget {
  constructor(element) {
    super(element);

    this.template =
      '<div class="chat-wrapper"> <div class="chat-header"> <h1>ChatBot</h1><div class="close-btn">–</div> </div> <div id="chat-container"></div> <div class="input-wrapper"> <input type="text" id="message-input" placeholder="Type your message here..." autofocus><div id="progress"><div class="dot-elastic"></div></div> </div> </div>';
    this.chatwindow;
    this.close_btn;

    if (!window.eHelpWebChat) window.eHelpWebChat = this;

    this.user = new User();
    this.state = STATES.CLOSED;

    this.init_assistan_btn = this.element.querySelector(".init-assistan-btn");

    this.init_assistan_btn.addEventListener("click", (e) => {
      if (this.state == STATES.CLOSED) {
        this.setState(STATES.OPEN);
        this.init();
      }
    });
  }
  async init() {
    const messages = [];


    let usecase = `<h1>${window.usecase.topicName}</h1>`;
    let step = 1;
    window.usecase.steps.forEach(item=>{
      usecase += `<strong>passo ${step}</strong>${item.text}`;
      step ++;
    });

    const userAgent = navigator.userAgent;

    messages.push({
      role: "user",
      content: `Eu tentei solucionar um problema visitando este passo a passo: \n${usecase}\n`,
    });

    this.state = "open";
    this.chatwindow = document.createElement("div");
    this.chatwindow.innerHTML = this.template;
    document.body.append(this.chatwindow);

    this.chatContainer = this.chatwindow.querySelector("#chat-container");
    this.messageInput = this.chatwindow.querySelector("#message-input");
    this.close_btn = this.chatwindow.querySelector(".close-btn");

    this.close_btn.addEventListener("click", (e) => {
      this.chatwindow.remove();
      this.setState(STATES.CLOSED);
    });
    this.messageInput.addEventListener("keydown", async (event) => {
      if (event.key === "Enter") {
        this.setState(STATES.LOADING);
        event.preventDefault();

        const userMessage = this.messageInput.value.trim();
        if (userMessage.length === 0) return;

        this.addMessageToChat("user-message", userMessage);
        this.messageInput.value = "";

        const chatGPTResponse = await this.sendMessageToChatGPT(userMessage);
        this.addMessageToChat("assistant-message", chatGPTResponse);
        this.setState(STATES.LOADED);
      }
    });
    this.setState(STATES.LOADING);

    const response = await this.fetchData(
      QelpCareHUB.root + "webchat/sendMessage",
      {
        messages: messages,
        user: this.user.data.id,
      }
    );
    const data = await response;
    console.log(data);

    this.setState(STATES.LOADED);

    this.addMessageToChat("assistant-message", data.choices[0].message.content);
  }
  setState(state) {
    switch (state) {
      case "loading":
        this.state = STATES.LOADING;
        this.chatwindow.className = STATES.LOADING;
        this.messageInput.setAttribute("disabled", true);
        break;
      case "loaded":
        this.state = STATES.LOADED;
        this.chatwindow.className = STATES.LOADED;
        this.messageInput.removeAttribute("disabled");
        this.messageInput.focus();
        break;
      default:
        this.state = state;
        break;
    }
  }
  addMessageToChat(messageClass, messageText) {
    const messageElement = document.createElement("pre");
    messageElement.classList.add("conversation");
    messageElement.classList.add(messageClass);
    messageElement.textContent = messageText;
    this.chatContainer.appendChild(messageElement);
    this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
  }
  async sendMessageToChatGPT() {
    const messages = [];


    messages.push({
      role: "user",
      content: `Eu tentei solucionar um problema seguindo este passo a passo::\n${this.user.data.history[0].uri}\n`,
    });

    const conversation = this.chatContainer.querySelectorAll(".conversation");

    conversation.forEach((item) => {
      const role = item.classList.contains("user-message")
        ? "user"
        : "assistant";
      const message = {
        role: role,
        content: item.innerHTML,
      };
      messages.push(message);
    });

    // if (this.parent?.config?.selected?.device?.manualUrl) {
      try {
        const response = await this.fetchData(
          QelpCareHUB.root + "webchat/chat",
          {
            messages: messages,
            device: this.parent?.config?.selected?.device || this.parent?.config?.selected?.os ,
            user: this.user.data.id,
          }
        );
        const data = await response;
        return data.choices[0].message.content;
      } catch (error) {
        console.error("Error communicating with server:", error);
      }
    // } else {
    //   try {
    //     const response = await this.fetchData(
    //       QelpCareHUB.root + "webchat/sendMessage",
    //       {
    //         messages: messages,
    //         user: this.user.data.id,
    //       }
    //     );
    //     const data = await response;
    //     return data.choices[0].message.content;
    //   } catch (error) {
    //     console.error("Error communicating with server:", error);
    //   }
    // }
  }
  async fetchData(url, requestData) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error communicating with server:", error);
    }
  }
}
const STATES = {
  OPEN: "open",
  LOADING: "loading",
  LOADED: "loaded",
  CLOSED: "closed",
};

window.addEventListener("eHelpFrameworkReady", (e) => {
  eHelpFramework.widgets.push(new WebChat(".webchat-banner"));
});
